export const getCleanBannerCode = code => {
    if (code === null || code === undefined) {
        return code;
    }
    const pattern = />\s*(.+)/;
    const match = code.match(pattern);
    if (match === null || match.length < 2) {
        return code;
    };
    return match[1];
};

export const findBannerByCode = (bannerList, code) => {
    if (!Array.isArray(bannerList) || bannerList.length === 0) {
        return undefined;
    }
    const banner = bannerList.find(item => item.code === code);
    return banner?.config;
};
